import React from "react";
import ReactECharts from "echarts-for-react";
const PaymentSuccessGauge = () => {
    const option = {
        series: [
            {
                type: "gauge",
                progress: {
                    show: true,
                    width: 18,
                    itemStyle: {
                        color: "#2f5aa2"
                    }
                },
                axisLine: { lineStyle: { width: 18 } },
                axisTick: { show: false },
                splitLine: { show: false },
                detail: {
                    valueAnimation: true,
                    formatter: "{value}%",
                    fontSize: 15
                },
                pointer: {
                    show: true,
                    length: "70%",
                    width: 4,
                    itemStyle: {
                        color: "#2f5aa2"
                    }
                },
                data: [{ value: 93}]
            }
        ]
    };

    return (
        <div className="card" style={{height: '450px'}}>
            <div className="card-body">
                <div>
                    <h5>Payment Success Rate</h5>
                    <p className="fs-9 fw-semibold">Users across countries</p>
                </div>
                <ReactECharts className='w-100' option={option} style={{ height: 280 }} />
            </div>
        </div>
    );
};
export default PaymentSuccessGauge;
